import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export const reportingPaymentsByClassAPI = async (params: {
  classId: string;
  format: string;
}) => {
  const response = await baseAPI.get<string>('/reporting/payments-by-class', {
    params,
    responseType: 'text',
  });
  return response.data;
};

export const useReportingPaymentsByClass = (params: {
  classId: string;
  format: string;
}) => {
  return useQuery({
    queryKey: [KEYS.PAYMENTS_BY_CLASS, params.classId, params.format],
    queryFn: () => reportingPaymentsByClassAPI(params),
    enabled: !!params.classId && !!params.format,
  });
};
